// extracted by mini-css-extract-plugin
export default {"content":"ModalNuevaTarifa_content__u6Zf9","input":"ModalNuevaTarifa_input__SnMmL"};